<template>
	<LayoutMain>
		<section>
			<h1>Hej <span v-html="userName"></span></h1>
			<RecentItems v-bind:search="searchinput" />
		</section>
	</LayoutMain>
</template>

<script>
	import LayoutMain from "@/components/common/LayoutMain.vue";
	import { types } from "@/app/types/types";
	import RecentItems from "@/components/start/RecentItemsList.vue";

	export default {
		name: "Start",
		data()
		{
			return {
				searchinput: ""
			}
		},
		computed:
		{
			userName()
			{
				return this.$store.getters[types.GET_USER_DATA].name
			}
		},
		components:
		{
			LayoutMain,
			RecentItems
		}
	};
</script>